export default __webpack_public_path__ + "static/media/cake_orange.632e6906.jpg";